import { useLocation, useNavigate } from 'react-router-dom'
import { createContext, useEffect, useState, useContext } from "react";
import { Box, Container } from "@mui/material";
import QMentisBreadCrumb from '../../custom-components/QMentisBreadCrumb';
import { Typography } from '@mui/material'
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import TestEnvironmentForm from '../../output-components/test-automation/TestEnvironment';
import TestCaseUI from '../../output-components/test-automation/TestCaseImported';
import Feature from '../../output-components/test-automation/FeatureFilesCreated';
import InputForm from '../../output-components/test-automation/PageSource';
import PageClass from '../../output-components/test-automation/PageClass';
import Locators from '../../output-components/test-automation/Locators';
import StepDefinition from '../../output-components/test-automation/StepDefinition';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { featureFilesWithToolCalling, pageClassAPI, playwrightCSharpSpecflowProjectWithToolCalling, stepDefinitionAPI } from '../../../services/webServices';
import { LoadingModalContext } from "../../main-pages/ServicePage";
import UploadBox from '../input-pages/UploadBox';
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import CommonDownload from "../../custom-components/CommonDownload";
import MessagePopup from '../../popup-components/MessagePopup';
import JSZip from "jszip";
import { saveAs } from "file-saver";

export const TestCaseFlowDataContext = createContext(null);

const PlayWrightCSharpNewProjectOutputPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [projectType, setProjectType] = useState("");
  const [testEnvironment, setTestEnviorment] = useState({});
  const [testCase, setTestCase] = useState({});
  const [featureFile, setFeatureFile] = useState('');
  const [pageSource, setPageSource] = useState('');
  const [locator, setLocator] = useState('');
  const [pageClass, setPageClass] = useState('');
  const [stepDefinition, setstepDefinition] = useState('');
  const { setLoadingState } = useContext(LoadingModalContext);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [zipBlob, setZipBlob] = useState(null); // ⬅ store zip here
  const [framework, setFramework] = useState('');


  useEffect(() => {
    console.log(location.state)
    setProjectType(location.state?.projectType || "");
    setTestEnviorment(location.state?.testenvironmentdata || {});
    setTestCase(location.state?.testCaseData || {});
    setFeatureFile(location.state?.featureFileData || "");
    setPageSource(location.state?.pageSource || "");
    setLocator(location.state?.generatedLocators || {});
    setPageClass(location.state?.generatedPageclassData || "");
    setstepDefinition(location.state?.generatedStepDefinitionData || "");
    setFramework(location.state?.framework || "")
  },
    [
      location.state?.projectType,
      location.state?.testenvironmentdata,
      location.state?.testCaseData,
      location.state?.featureFileData,
      location.state?.pageSource,
      location.state?.generatedLocators,
      location.state?.generatedPageclassData,
      location.state?.generatedStepDefinitionData,
      location.state?.framework
    ]);


  const breadCrumbs = [
    {
      title: "Set Test Environment",
      status: Object.entries(testEnvironment).length !== 0 || confirmed ? "Completed" : "In Progress",
    },
    {
      title: "Test Case Details",
      status: Object.entries(testCase).length > 0
        ? "Completed"
        : Object.entries(testEnvironment).length !== 0 && Object.entries(testCase).length === 0
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Feature Files",
      status:
        !!featureFile && featureFile !== ""
          ? "Completed"
          : Object.entries(testCase).length > 0
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Introduce SUT",
      status:
        !!pageSource && pageSource !== ""
          ? "Completed"
          : (!!featureFile && featureFile !== "")
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Locators",
      status:
        Object.keys(locator).length > 0
          ? "Completed"
          : !!pageSource && pageSource !== ""
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Page Class",
      status:
        !!pageClass && pageClass !== ""
          ? "Completed"
          : Object.keys(locator).length > 0
            ? "In Progress"
            : "Not Started",
    },

    {
      title: "Step Definition",
      status:
        (!!stepDefinition && stepDefinition !== "")
          ? "Completed"
          : !!pageClass && pageClass !== ""
            ? "In Progress"
            : "Not Started",
    },
  ];

  const handleGenerateFeatureFile = async () => {
    // setLoading(true)
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 1.0;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Feature File",
      progress: 0,
    });

    fake = startProgress(setLoadingState);
    try {
      // Your API call to generate feature files
      const generatedFeatureFileResponse = await featureFilesWithToolCalling(testCase);
      // Make sure to define testCasesData
      const generatedFeatureFile = generatedFeatureFileResponse.data;
      navigate(location.pathname, { state: { ...location.state, featureFileData: generatedFeatureFile }, replace: true })
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      setLoadingState({ open: false, message: "", progress: null });
    }
    finally {
      // setLoading(false);
      setLoadingState({ open: false, message: "", progress: null });
    }
  };


  const primaryFieldsObject = getPrimaryFields(locator);

  const handlePageClass = async () => {
    // setLoading(true);
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 1.0;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Page Class",
      progress: 0,
    });

    fake = startProgress(setLoadingState);
    try {
      const generatedPageClassGenerated = await pageClassAPI(primaryFieldsObject, location.state?.framework);
      const generatedPageClass = generatedPageClassGenerated.data;
      navigate(location.pathname, { state: { ...location.state, generatedPageclassData: generatedPageClass }, replace: true });
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      setLoadingState({ open: false, message: "", progress: null });
    }
    finally {
      setLoadingState({ open: false, message: "", progress: null });
    }

  }

  const handleStepDefinition = async () => {
    // setLoading(true);
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 1.0;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Step Definition",
      progress: 0,
    });

    fake = startProgress(setLoadingState);
    try {
      const pageClassData = {
        "pageClassGenerated": pageClass
      };
      const generatedStepDefinitionGenerated = await stepDefinitionAPI({ featureFileGenerated: featureFile, pageClassData }, location.state?.framework);
      const generatedStepDefinition = generatedStepDefinitionGenerated.data;
      navigate(location.pathname, { state: { ...location.state, generatedStepDefinitionData: generatedStepDefinition }, replace: true });
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      setLoadingState({ open: false, message: "", progress: null });
    }
    finally {
      setLoadingState({ open: false, message: "", progress: null });
    }

  }

  const handleProjectGeneration = async () => {
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 1.0;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Feature File",
      progress: 0,
    });

    fake = startProgress(setLoadingState);

    try {
      const projectReqBody = {
        "featureFileGenerated": featureFile,
        "pageClassData": pageClass,
        "stepDefinitionData": stepDefinition,
        "testEnvironmentData": testEnvironment
      }

      const projectFilesResponse = await playwrightCSharpSpecflowProjectWithToolCalling(projectReqBody);

      const testData = projectFilesResponse.data["Test Data"];
      const runnerFile = projectFilesResponse.data["Other Project Files"]["Runner"];
      const appsettings = projectFilesResponse.data["Configuration"]["appsettings"];
      const runsettings = projectFilesResponse.data["ProjectMetadata"]["runsettings"];
      const csproj = projectFilesResponse.data["ProjectMetadata"]["csproj"];
      const readme = projectFilesResponse.data["Documentation"]["README.md"];

      const utilityFile = `using Microsoft.Playwright;
using System;
using System.Linq;
using System.Threading.Tasks;

namespace Utilities
{
    public class Utility
    {
        private readonly IPage _page;

        public Utility(IPage page)
        {
            _page = page ?? throw new ArgumentNullException(nameof(page));
        }

        #region Navigation

        public async Task GoToUrlAsync(string url)
        {
            if (string.IsNullOrWhiteSpace(url))
                throw new ArgumentException("URL cannot be null or empty", nameof(url));

            await _page.GotoAsync(url, new PageGotoOptions
            {
                WaitUntil = WaitUntilState.NetworkIdle
            });
        }

        public Task<string> GetPageTitleAsync() => _page.TitleAsync();

        public Task<string> GetCurrentUrlAsync() => Task.FromResult(_page.Url);

        #endregion

        #region Element Interaction

        public async Task ClickAsync(string selector)
        {
            try
            {
                await _page.Locator(selector).ClickAsync();
            }
            catch (Exception ex)
            {
                throw new InvalidOperationException($"Failed to click on element '{selector}'.", ex);
            }
        }

        public async Task TypeAsync(string selector, string text, bool clear = true)
        {
            var element = _page.Locator(selector);
            if (clear)
                await element.FillAsync(""); // clear existing text
            await element.TypeAsync(text);
        }

        public async Task FillAsync(string selector, string value)
        {
            await _page.Locator(selector).FillAsync(value);
        }

        public async Task SelectDropdownByValueAsync(string selector, string value)
        {
            await _page.Locator(selector).SelectOptionAsync(new SelectOptionValue { Value = value });
        }

        public async Task SelectDropdownByTextAsync(string selector, string text)
        {
            await _page.Locator(selector).SelectOptionAsync(new SelectOptionValue { Label = text });
        }

        public async Task HoverAsync(string selector)
        {
            await _page.Locator(selector).HoverAsync();
        }

        public async Task CheckCheckboxAsync(string selector)
        {
            await _page.Locator(selector).CheckAsync();
        }

        public async Task UncheckCheckboxAsync(string selector)
        {
            await _page.Locator(selector).UncheckAsync();
        }

        #endregion

        #region Element Retrieval

        public async Task<string> GetTextAsync(string selector)
        {
            return await _page.Locator(selector).InnerTextAsync();
        }

        public async Task<string> GetAttributeAsync(string selector, string attributeName)
        {
            return await _page.Locator(selector).GetAttributeAsync(attributeName);
        }

        public async Task<bool> IsVisibleAsync(string selector, int timeout = 5000)
        {
            try
            {
                var locator = _page.Locator(selector);

                // Wait until element is attached and visible
                await locator.WaitForAsync(new LocatorWaitForOptions
                {
                    State = WaitForSelectorState.Visible,
                    Timeout = timeout
                });

                return await locator.IsVisibleAsync();
            }
            catch (TimeoutException)
            {
                return false; // Element not visible within timeout
            }
        }

        public async Task<bool> IsEnabledAsync(string selector)
        {
            return await _page.Locator(selector).IsEnabledAsync();
        }

        #endregion

        #region Waits

        public async Task WaitForSelectorAsync(string selector, int timeout = 5000)
        {
            await _page.WaitForSelectorAsync(selector, new PageWaitForSelectorOptions
            {
                State = WaitForSelectorState.Attached,
                Timeout = timeout
            });
        }

        public async Task WaitForElementToBeVisibleAsync(string selector, int timeout = 5000)
        {
            await _page.WaitForSelectorAsync(selector, new PageWaitForSelectorOptions
            {
                Timeout = timeout,
                State = WaitForSelectorState.Visible
            });
        }

        public async Task WaitForPageLoadAsync()
        {
            await _page.WaitForLoadStateAsync(LoadState.NetworkIdle);
        }

        #endregion

        #region JavaScript Helpers

        public async Task ScrollToElementAsync(string selector)
        {
            await _page.Locator(selector).ScrollIntoViewIfNeededAsync();
        }

        public async Task ExecuteJsAsync(string script, object arg = null)
        {
            await _page.EvaluateAsync(script, arg);
        }

        #endregion

        #region Screenshots

        public async Task TakeScreenshotAsync(string filePath)
        {
            await _page.ScreenshotAsync(new PageScreenshotOptions
            {
                Path = filePath,
                FullPage = true
            });
        }

        #endregion

        #region Alerts / Dialogs

        public void HandleDialog(string action = "accept", string inputText = "")
        {
            _page.Dialog += async (_, dialog) =>
            {
                if (action.ToLower() == "accept")
                    await dialog.AcceptAsync(inputText);
                else
                    await dialog.DismissAsync();
            };
        }

        #endregion

        #region Frames / Windows

        public IFrame GetFrameByName(string frameName)
        {
            return _page.Frames.FirstOrDefault(f => f.Name == frameName);
        }

        public IFrame SwitchToFrame(string frameName)
        {
            var frame = GetFrameByName(frameName);
            if (frame == null)
                throw new Exception($"Frame {frameName} not found");
            return frame;
        }

        public IBrowserContext GetContext()
        {
            return _page.Context;
        }

        #endregion
    }
}
`;

      const zip = new JSZip();

      const featureFolder = zip.folder("Playwright_C_Sharp_Specflow/Features");
      featureFolder.file("FeatureFile.feature", featureFile);

      const pageClassFolder = zip.folder("Playwright_C_Sharp_Specflow/Pages");
      if (typeof pageClass !== "string" && Array.isArray(pageClass)) {
        pageClass.map((eachClass) => {
          Object.entries(eachClass).map(([key, value]) => {
            pageClassFolder.file(`${key}.cs`, value);
          });
        });
      } else {
        pageClassFolder.file("PageClass.cs", pageClass);
      }

      const resourceFolder = zip.folder("Playwright_C_Sharp_Specflow/Resources");
      resourceFolder.file("TestData.json", testData);

      const stepDefinitionFolder = zip.folder("Playwright_C_Sharp_Specflow/StepDefinitions");
      if (typeof stepDefinition !== "string" && Array.isArray(stepDefinition)) {
        stepDefinition.map((eachClass) => {
          Object.entries(eachClass).map(([key, value]) => {
            stepDefinitionFolder.file(`${key}.cs`, value);
          });
        });
      } else {
        stepDefinitionFolder.file("StepDefinition.cs", stepDefinition);
      }

      const utilitiesFolder = zip.folder("Playwright_C_Sharp_Specflow/Utilities");
      utilitiesFolder.file("Utility.cs", utilityFile);

      zip.file("Playwright_C_Sharp_Specflow/appsettings.json", appsettings);
      zip.file("Playwright_C_Sharp_Specflow/Playwright_C_Sharp_Specflow.csproj", csproj);
      zip.file("Playwright_C_Sharp_Specflow/Playwright_C_Sharp_Specflow.runsettings", runsettings);
      zip.file("Playwright_C_Sharp_Specflow/README.md", readme);

      zip.generateAsync({ type: "blob" }).then((content) => {
        setZipBlob(content); // store in local state
        saveAs(
          content,
          "Playwright_C_Sharp_Specflow"
        );
      });

    } catch (error) {
      const errorMsg =
        error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      setLoadingState({ open: false, message: "", progress: null });
    }
  }

  function getPrimaryFields(response) {
    const primaryFields = {};
    for (const key in response) {
      if (response[key].primary) {
        if (response[key].primary[0].startsWith("class")) {
          primaryFields[key] = response[key].secondary;
        } else {
          primaryFields[key] = response[key].primary;
        }
      }
    }
    return primaryFields;
  };

  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  const handleGitHubProject = async () => {
    console.log("Navigating to GitHub with zipBlob:", zipBlob);

    if (!zipBlob) {
      console.error("ZIP file not generated yet.");
      return;
    }
    navigate(`/dashboard/test-automation/newproject-gitcredentials`, {
      state: {
        framework: framework,
        projectType: projectType,
        zipFile: zipBlob,
      },
    });
  };


  const testcaseNextButton = {
    label: "Generate Feature File",
    onClick: handleGenerateFeatureFile,
    startIcon: <GenerateButton />,
    variant: "contained",
    sx: { float: "right" },
  };

  const javaSeliniumDownloadButton = {
    label: "Download",
    onClick: handleDownloadClick,
    variant: "text",
    startIcon: <SaveAltRoundedIcon />,
    sx: { textTransform: "none" },
  };

  const locatorsNextButton = {
    label: "Generate Page Class",
    variant: "contained",
    onClick: handlePageClass,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }

  const stepDefinitionNextButton = {
    label: "Generate Step Definition",
    variant: "contained",
    onClick: handleStepDefinition,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }

  const projectGenerationButton = [
    {
      label: "Generate Project",
      variant: "contained",
      onClick: handleProjectGeneration,
      startIcon: <GenerateButton />,
      sx: { float: "right" },
    },
    {
      label: "Push to GitHub",
      variant: "contained",
      startIcon: <GenerateButton />,
      sx: { marginRight: 1, whiteSpace: "nowrap" },
      onClick: handleGitHubProject,
      disabled: !zipBlob, // Disable if zipBlob is not available
    },
  ]

  const handleCloseDownload = () => {
    setDownloadOpen(false);
  }

  const formatTestPlan = (testPlanData) => {
    const formattedTestPlan = {};
    Object.entries(testPlanData).map(([key, value]) => {
      // console.log(typeof value);
      // console.log(value)
      if (Array.isArray(value)) {
        return (formattedTestPlan[key] = flattenArray(value));
      }
      if (!!value && typeof value === "object") {
        return (formattedTestPlan[key] = flattenObject(value));
      }
      return (formattedTestPlan[key] = value);
    });
    // console.log(formattedTestPlan)
    return formattedTestPlan;
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >

      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0", // Adjust this value as needed to place the breadcrumb where you want it
            width: "100%",
            zIndex: 1000, // Ensure it stays above other content
            bgcolor: "white", // Background color to prevent transparency
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Optional shadow for visual separation
          }}
        >


          <QMentisBreadCrumb breadCrumbs={breadCrumbs} sx={{ height: "56px" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              margin: "10px auto",
              "& > *:not(:last-child)": {
                marginBottom: "16px", // Adds margin between components but not after the last one
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate automated test scripts
                </Typography>
              </Box>
              <FullscreenToggle />




            </Box>
            {/* JAVA SELENIUM COMPONENTS */}
            {/* {Object.entries(testEnvironment).length === 0 && ( */}
            <TestEnvironmentForm
              testEnvironmentData={testEnvironment}
              setTestEnviorment={setTestEnviorment}
              framework={location.state?.framework}
              confirmed={confirmed}
              setConfirmed={setConfirmed}
              projectType={projectType}
            />
            {/* )} */}

            {/* <UploadBox testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} /> */}
            {confirmed && (
              <UploadBox
                testCaseData={testCase}
                setTestCase={setTestCase}
                testcaseNextButton={testcaseNextButton}
                javaSeliniumDownloadButton={javaSeliniumDownloadButton}
                projectType={projectType}
              />
            )}
            {Object.entries(testCase).length > 0 && <TestCaseUI testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} projectType={projectType} />}
            {!!featureFile && featureFile !== "" && <Feature featureFile={featureFile} setFeatureFile={setFeatureFile} projectType={projectType} />}
            {!!featureFile && featureFile !== "" && <InputForm setPageSource={setPageSource} />}
            {Object.entries(locator).length > 0 && <Locators locator={locator} setLocator={setLocator} locatorsNextButton={locatorsNextButton} projectType={projectType} />}
            {!!pageClass && pageClass !== "" && <PageClass pageClass={pageClass} setPageClass={setPageClass} featureFile={featureFile} stepDefinitionNextButton={stepDefinitionNextButton} projectType={projectType} />}
            {!!stepDefinition && stepDefinition !== "" && <StepDefinition stepDefinition={stepDefinition} setstepDefinition={setstepDefinition} featureFile={featureFile} pageClass={pageClass} framework={location.state?.framework} projectType={projectType} testEnvironmentData={testEnvironment} nextButton={projectGenerationButton} />}
          </Box>
        </Box>
        {/* Add padding-top to avoid overlap with the fixed breadcrumb */}
        <Container
          sx={{
            // paddingTop: "50px", // Adjust this value based on the height of the breadcrumb
            width: "100%",
          }}
        >


          {/* <TestCaseFlowDataContext.Provider
            value={{
              testCaseDetails,
              setTestCaseDetails,
              featureFiles,
              setFeatureFiles,
              pageSources,
              setPageSources,
              locators,
              setLocators,
              pageClasses,
              setPageClasses,
              stepDefinitions,
              setstepDefinitions,

            }}
          > */}


          {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
              <Button
                startIcon={<DownloadIcon />}
                color="#80c3d8"
                sx={{ textTransform: "none", marginRight: '15px', color: '#53adcb', border: '2px solid #53adcb', }}
              >
                Upload
              </Button>
            </Box> */}



          {/* </TestCaseFlowDataContext.Provider> */}
        </Container>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI tools.
        </Typography>
      </Box>
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
      <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
        wordData={[
          {
            type: "subParagraphs",
            data: testCase,
          },
        ]}
        serviceName={"Test Case Details"}
        serviceResponse={formatTestPlan(testCase)}
        documents={['xls', 'csv']}
      />
    </Box>
  );
};


export default PlayWrightCSharpNewProjectOutputPage;